import { Action } from '@ngrx/store';
import { UserBusiness  } from '@app/models/user-business';

export enum UserBusinessActionTypes {
    Load = '[API] Load User business',
    LoadSuccess = '[API] Load User business success',
    LoadFail = '[API] Load User business fail'
}

export class Load implements Action {
  readonly type = UserBusinessActionTypes.Load;
  constructor(public UserId: number) {}
}

export class LoadSuccess implements Action {
  readonly type = UserBusinessActionTypes.LoadSuccess;
  constructor(public userBusinesses: any[]) {}
}

export class LoadFail implements Action {
  readonly type = UserBusinessActionTypes.LoadFail;
  constructor(public error: any) {}
}

export type UserBusinessActionsUnion =
    | Load
    | LoadSuccess
    | LoadFail;
